import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { CookieService } from 'ngx-cookie-service';
import { BaseRichService } from '../../../providers/base-rich.service';
import { AccountFormComponent } from '../account-form/account-form.component';

@Component({
  selector: 'app-account-natural-form',
  templateUrl: '../../shared/base-form/base-form.component.html',
  styleUrls: ['./account-natural-form.component.scss', '../../shared/base-form/base-form.component.scss']
})
export class AccountNaturalFormComponent extends AccountFormComponent implements OnInit {

  constructor(
    public cookieService: CookieService,
    public activeModal: NgbActiveModal,
    public titleService: Title,
    public translator: TranslateService,
    public service: BaseRichService,
  ) {
    super(cookieService, activeModal, titleService, translator, service);
    this.subentityName = 'natural';
  }

  async valueChanged(e) {
    if (e.value) {
      switch (e.element.id) {
        case 'nationality':
          const fieldIdentificationNo = this.fields.find(fc => fc.name === 'identification_no');
          const fieldCertificateNo = this.fields.find(i => i.name === 'certificate_no');
          const fieldFatherName = this.fields.find(i => i.name === 'father_name');
          if (e.value !== 'IRN') {
            this.changeValue('identification_type', 'FD');
            fieldCertificateNo.rules = [];
            fieldFatherName.rules = [];
            fieldIdentificationNo.rules = [{ type: 'required' }];
            this.changeValue('certificate_no', undefined);
            this.changeDisabled('certificate_no', true);
          } else {
            this.changeValue('identification_type', 'NC');
            fieldFatherName.rules = [{ type: 'required' }];
            fieldCertificateNo.rules = [{ type: 'required' }, { type: 'stringLength', min: 1, max: 10 }];
            fieldIdentificationNo.rules = [{ type: 'required' }, { type: 'stringLength', min: 10, max: 10 }];
            this.changeDisabled('certificate_no', false);
          }
          break;
        default:
          await super.valueChanged(e);
          break;
      }
    }
  }

  async customize(field) {
    if (['certificate_no', 'father_name'].includes(field.name) && this.formData.nationality !== 'IRN') {
      field.rules = [];
    }
    await super.customize(field);
  }

  addUploadColumns(id: any) {
    super.addUploadColumns(id);
    if (!this.fields.find(c => c.name === 'certificate_pic')) {
      this.fields.push({
        name: 'certificate_pic',
        caption: this.translator.instant('CERTIFICATE_PIC'),
        editorType: 'dxFileUploader',
        type: {
          name: 'uploader'
        }
      }, {
        name: 'identification_pic',
        caption: this.translator.instant('IDENTIFICATION_PIC'),
        editorType: 'dxFileUploader',
        type: {
          name: 'uploader'
        }
      });
    }
  }

  // async ngOnInit(): Promise<void> {
  //   await super.ngOnInit();
  //   if (!this.isEdit) {
  //     setTimeout(() => {
  //       this.changeValue('identification_type', 'NC');
  //       // this.formData['identification_type'] = 'NC';
  //     }, 200);
  //   } else if (!this.roles.includes('SALES_MNG')) {
  //     this.changeDisabled('identification_no', true)
  //   }
  // }
}
